import { render, staticRenderFns } from "./perecord.vue?vue&type=template&id=630ed5f4&scoped=true&"
import script from "./perecord.vue?vue&type=script&lang=js&"
export * from "./perecord.vue?vue&type=script&lang=js&"
import style0 from "./perecord.vue?vue&type=style&index=0&id=630ed5f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ed5f4",
  null
  
)

export default component.exports